import React from "react";
import {
  ComponentDetailsByFileOut,
  PropertyTypeChoices,
  PropertyValue,
} from "api-client";
import { FIELDSSET_TITLE_CLASSES } from "features/MappingEditor/consts";
import { useTranslation } from "react-i18next";
import PropertyRow from "../../PropertyManager/components/PropertyRow";
import { Property } from "features/BuildingProductEditor/ProductEditorStore";

const OwnProperties = ({
  details,
}: {
  details: ComponentDetailsByFileOut | undefined;
}) => {
  const { t } = useTranslation();

  const properties = Object.entries(details?.org_properties ?? {}).map(
    (rec) =>
      ({
        id: rec[0],
        slug: rec[0],
        name: rec[1].name,
        property_type: rec[1].property_type as PropertyTypeChoices,
        value: rec[1].value as PropertyValue,
      } as Property)
  );

  if (!properties?.length) return;
  return (
    <div className="py-6 border-b border-gray-200">
      <div className={FIELDSSET_TITLE_CLASSES}>
        {t("productEditor.ownProperties")}
      </div>
      <div className="border border-gray-300 rounded-md text-sm font-medium">
        {properties.map((item, index) => (
          <PropertyRow key={item.slug} property={item} index={index} />
        ))}
      </div>
    </div>
  );
};

export default OwnProperties;
